const returnValue = (newData) => {
    let SelectedValue = null
    if (Array.isArray(newData)) {
        SelectedValue = newData?.map((data) => data.value)
    } else {
        SelectedValue = newData?.value
    }
    return SelectedValue
}
export default returnValue;